module.exports = __webpack_public_path__ + "img/home-07-cosmopolitan-sample-04-food-hand.e1f217de.png";